import React, { useLayoutEffect } from 'react';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import {
  primaryFont, primaryHeadingColor, secondaryFont, wLight,
  wMedium, maxWidth, retina, tabHeading, wMLight, maxMobile,
} from 'Utils/utilsStyle';
import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import TypographyBlock from 'Components/common/components/TypographyBlock';
import PillsBlock from 'Components/common/components/PillsBlock';
import { useDispatch, useSelector } from 'react-redux';
import {
  navigationTabsPersonProfile, personCard, personProfilePersonalDetails, profileLoading,
} from 'Selector/PersonProfileSelector';
import PersonalityDetailSkeleton from 'Components/common/skeleton/PersonalityDetailSkeleton';
import { useNavigate } from 'react-router-dom';

import { PersonCard } from 'Types/PersonTypes';
import InterestIcon from 'Components/common/assets/svgIcons/InterestIcon';
import HobbyIcon from 'Components/common/assets/svgIcons/HobbyIcon';
import { PERSONALITY_INSIGHTS_ROUTE } from 'Utils/Constants';

// import HTMLReactParser from 'html-react-parser';
// import PersonalityDetailSkeleton from 'Components/common/skeleton/PersonalityDetailSkeleton';

// type PersonalStat = {
//   label: string;
//   stat: string
// };

type Props = {
  personId?: number;
  personType?: string;
};

const Wrapper = styled.div`
  .personal-detail-heading {
    ${tabHeading};
     @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 22px;
      line-height: 26px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 16px;
      line-height: 20px;
    }
  } 
  .StatesWidgetPrimary-art {
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-top: 8px;
    }
    .states-widget-primary-row {
      .states-widget-primary-col {
        @media all and (max-width: ${maxMobile}) {
          flex: 0 0 100%;
          max-width: 100%;
        }
      }
    }
  }
  h2{
    color:${primaryHeadingColor};
    font-size:28px;
    font-weight:${wLight};
    font-family:${secondaryFont};
    margin-bottom:25px;
  }
  .mt-90{
    margin-top:60px;
  }
  .mb-90{
    margin-bottom: 90px;
  }
  .interests-hobbies {
    margin-bottom: 50px;
    .pills-block-style-wrapper {
      .mobile-size-icon {
        @media all and (max-width: ${maxMobile}){
          height:13px;
          width:13px;
        }
      }
    }
  }
  .about-container {
    padding: 0px;
    margin-top: 16px;
      /* .email-phone-container{
        @media all and (max-width: ${maxWidth}), ${retina}{
          height: 112px;
        }
      } */
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 0px 0px 0px 0px;
    }
    body {
      font-family: ${primaryFont} !important;
      font-weight: ${wMedium};
      font-size: 16px;
      letter-spacing: -0.42px;
      line-height: 25px;
      color: #67696A;
      margin-bottom: 0px;
    }
    .item {
      h3 {
        font-family: ${primaryFont};
        font-weight: ${wMedium};
        font-size: 20px;
        letter-spacing: -0.42px;
        line-height: 30px;
        color: ${primaryHeadingColor};
        margin-bottom: 0;
      }
      div, div > span, p {
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 16px;
      letter-spacing: -0.42px;
      line-height: 25px;
      color: #67696A;
      margin-bottom: 3px;
      }
    }
  }
`;

const StatesWidget = styled.div<{ detailsColor?: string }>`
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.04); 
  padding: 30px 0px;
  width: 100%;

 .heading-stat {
  color: #67696A;
  text-align: center;
  font-family: ${primaryFont};
  font-size: 14px;
  font-weight: ${wMLight};
  line-height: 30px;
  letter-spacing: -0.417px;
  margin-bottom: 0px;
 }
 .details-about {
  color: ${(props) => (props.detailsColor ? props.detailsColor : 'rgb(126,126,126)')};
  text-align: center;
  font-family: ${secondaryFont};
  font-size: 18px;
  font-style: normal;
  font-weight: ${wMedium};
  line-height: 24px;
  letter-spacing: -0.6px;
  padding: 0 10px;
  @media all and (max-width: ${maxMobile}) {
    font-size: 16px;
    line-height: 18px;
  }
 }
`;

const defaultProps = {
  personId: 0,
  personType: '',
};

const PersonalDetails: React.FC<Props> = function PersonalDetails({ personId, personType }) {
  const dispatch = useDispatch();
  const {
    hobbies, interests, personalInfo, loading, title,
  } = useSelector(personProfilePersonalDetails);
  const personProfileCard: PersonCard = useSelector(personCard);
  const tabs = useSelector(navigationTabsPersonProfile);
  const cardLoading = useSelector(profileLoading);
  const color = personProfileCard?.archeType?.color;
  const navigate = useNavigate();
  const {
    address, about, family,
  } = personalInfo;

  useLayoutEffect(() => {
    if (!loading && !tabs.includes('Personal')) {
      const navLink = `${PERSONALITY_INSIGHTS_ROUTE}${personId || 0}&personType=${personType || ''}`;
      navigate(navLink, { replace: true });
    }
    if (personId && !title) {
      dispatch(personProfileActions.getPersonProfilePersonalDetails({
        personId,
        type: personType,
      }));
    }
  }, [personId, tabs]);

  return (
    <Wrapper>
      <span className="personal-detail-heading">
        Personal
      </span>
      {loading ? <PersonalityDetailSkeleton /> : (
        <>
          <div className="StatesWidgetPrimary-art">
            <Row gutter={[16, 16]} className="states-widget-primary-row">
              {/* {highlightedInfo?.map((item) => (
                item.value !== '' && item.value !== '0.0' && ( */}
              {address ? (
                <Col span={family ? 12 : 24} className="states-widget-primary-col gutter-row d-flex justify-content-center">
                  <StatesWidget detailsColor={color}>
                    <h6 className="heading-stat">Address</h6>
                    <p className="details-about">{address}</p>
                  </StatesWidget>
                </Col>
              )
                : null}
              {
                family
                  ? (
                    <Col span={address ? 12 : 24} className="states-widget-primary-col gutter-row d-flex justify-content-center">
                      <StatesWidget detailsColor={color}>
                        <h6 className="heading-stat">Family</h6>
                        <p className="details-about">{family}</p>
                      </StatesWidget>
                    </Col>
                  ) : null
              }
            </Row>
          </div>
          <div className="about-container">
            {about && (
              <TypographyBlock
                title="About"
                description={about}
              />
            )}
            {/* {address && (
              <TypographyBlock
                title="Address"
                description={address}
                rows={3}
              />
            )} */}
            {!cardLoading ? (
              <>
                {!personProfileCard?.email ? null
                  : (
                    <div className="email-container">
                      <TypographyBlock
                        title="Email Address"
                        description={personProfileCard?.email}
                        rows={3}
                        editable={personProfileCard?.isAdmin}
                        customClass="email-phone-container"
                      />
                    </div>
                  )}
                {!personProfileCard?.phone ? null
                  : (
                    <TypographyBlock
                      title="Phone Number"
                      description={personProfileCard?.phone}
                      rows={3}
                      editable={personProfileCard?.isAdmin}
                      isPhone
                      customClass="email-phone-container"
                    />
                  )}
              </>
            ) : null}
            {/* {family && (
              <TypographyBlock
                title="Family Members"
                description={family}
                rows={3}
              />
            )} */}
          </div>
          <Row gutter={[24, 24]} className="interests-hobbies">
            {hobbies.length > 0 && (
              <Col span={24} xs={24} sm={24} md={24}>
                <PillsBlock
                  title="Hobbies"
                  keywords={hobbies}
                  personalDetails
                  icon={<HobbyIcon />}
                />
              </Col>
            )}
            {interests.length > 0 && (
              <Col span={24} xs={24} sm={24} md={24}>
                <PillsBlock
                  title="Interests"
                  keywords={interests}
                  personalDetails
                  icon={<InterestIcon />}
                />
              </Col>
            )}

          </Row>
        </>
      )}

    </Wrapper>
  );
};

PersonalDetails.defaultProps = defaultProps;

export default PersonalDetails;
